var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailConfigIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52539 10.3682L14.0747 14.0863C16.4675 15.4447 17.531 15.4447 19.9238 14.0863L26.4731 10.3682",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0523 24.0953C16.0523 24.0953 15.1704 24.1184 14.2511 24.0953C11.2681 24.0202 9.7766 23.9827 8.70492 22.9054C7.63324 21.828 7.60227 20.3737 7.54033 17.465C7.52041 16.5299 7.52041 15.6001 7.54033 14.6649C7.60226 11.7562 7.63323 10.3019 8.70492 9.22459C9.7766 8.14727 11.2681 8.10975 14.2511 8.0347C16.0897 7.98843 17.9101 7.98843 19.7486 8.0347C22.7315 8.10976 24.2231 8.14729 25.2948 9.22461C26.3664 10.3019 26.3974 11.7563 26.4593 14.6649C26.4665 15.0035 26.4711 15.5901 26.4731 16.065",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6841 24.7821V26.0001M22.6841 24.7821C21.5881 24.7821 20.6227 24.2437 20.0563 23.4263M22.6841 24.7821C23.78 24.7821 24.7455 24.2437 25.3118 23.4263M20.0563 23.4263L18.8949 24.173M20.0563 23.4263C19.7214 22.9429 19.5262 22.3619 19.5262 21.7369C19.5262 21.1119 19.7213 20.5309 20.0562 20.0476M25.3118 23.4263L26.4732 24.173M25.3118 23.4263C25.6467 22.9429 25.842 22.3619 25.842 21.7369C25.842 21.1119 25.6468 20.5309 25.3119 20.0476M22.6841 18.6917C23.7801 18.6917 24.7457 19.2301 25.3119 20.0476M22.6841 18.6917C21.588 18.6917 20.6225 19.2301 20.0562 20.0476M22.6841 18.6917V17.4736M25.3119 20.0476L26.4736 19.3008M20.0562 20.0476L18.8945 19.3008",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailConfigIcon);
export default __webpack_public_path__ + "static/media/mailConfigIcon.59c6a183de5a58d36d7aa0e8608daabd.svg";
export { ForwardRef as ReactComponent };